import DefaultApiService from "./default";

const base = "SLN/Supervisor/InstalledEquipmentAsset";

const InstalledEquipmentAssetApi = {
  getByRequest: (requestId) =>
    DefaultApiService.get(`${base}/GetByRequest`, { requestId }),
  getById: (id) => DefaultApiService.get(`${base}/GetById`, { id }),
  saveAsset: (model) => DefaultApiService.post(`${base}/SaveAsset`, model),
  verifyAsset: (assetId) =>
    DefaultApiService.post(`${base}/VerifyAsset`, { assetId }),
  saveWarranty: (model) =>
    DefaultApiService.post(`${base}/SaveWarranty`, model),
};

export default InstalledEquipmentAssetApi;
